import { render, staticRenderFns } from "./ItemFormCopy.vue?vue&type=template&id=21112366&scoped=true&"
import script from "./ItemFormCopy.vue?vue&type=script&lang=js&"
export * from "./ItemFormCopy.vue?vue&type=script&lang=js&"
import style0 from "./ItemFormCopy.vue?vue&type=style&index=0&id=21112366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21112366",
  null
  
)

export default component.exports